import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const TitleContainer = styled.div`
  flex: 1;
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;

  min-width: 0;
  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IllustrationContainer = styled.span<{
  $color: string | null | undefined;
}>`
  color: ${({ theme, $color }) => $color ?? theme.palette.grey[600]};
  font-size: 2rem;
  line-height: 62.5%;
`;

export const IconContainer = styled.span`
  display: block;

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  overflow: hidden;

  line-height: 62.5%;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h6)};
  flex: 1;
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Interactions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1.5)};

  position: relative;

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const FavoriteButtonContainer = styled.div<{ $isFavorite: boolean }>`
  ${({ theme, $isFavorite }) =>
    $isFavorite &&
    css`
      color: ${theme.palette.warning.main};
      fill: ${theme.palette.warning.main};
    `};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;
